import React from 'react';

import { useTranslation } from 'react-i18next';

import { useNode } from '@craftjs/core';

import NumberInput from '@common/components/NumberInput/NumberInput';

import { Box } from '@mui/material';
import SelectWithOptions from '@common/components/SelectWithOptions/SelectWithOptions';
import { FONT_FAMILY_OPTIONS } from '@common/constants';

const FontSizeStyle = ({ max = 60, min = 0 }) => {
  const { t } = useTranslation();
  const {
    actions: { setProp },
    fontSize,
    fontFamily,
  } = useNode(({ data: { props } }) => {
    return {
      fontSize: props.fontSize,
      fontFamily: props.fontFamily,
    };
  });

  const onChange = (e) => {
    setProp((props) => {
      props[e.target.name] = e.target.value;
    }, 500);
  };

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}
    >
      <NumberInput
        min={min}
        max={max}
        label={`${t('font_size')}`}
        value={fontSize || ''}
        name='fontSize'
        onChange={onChange}
      />
      <SelectWithOptions
        name='fontFamily'
        label={`${t('font_style')}`}
        value={fontFamily || ''}
        onChange={onChange}
        options={FONT_FAMILY_OPTIONS}
      />
    </Box>
  );
};

export default FontSizeStyle;
